<template>
  <div class="user-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 placeholder="请输入手机号或者昵称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           ref="userList"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 修改密码 -->
    <Modal v-model="showEditPwdStatus"
           title="修改密码"
           @on-ok="updatePassword('userPwdValidate')"
           :loading="loading">
      <Form :model="userPwd"
            ref="userPwdValidate"
            :rules="userPwdValidate"
            action="javascript:void(0)">
        <FormItem label="密码"
                  prop="password">
          <Input v-model="userPwd.password"
                 type="password"
                 placeholder="输入密码..."></Input>
        </FormItem>
        <FormItem label="确认密码"
                  prop="password_confirmation">
          <Input v-model="userPwd.password_confirmation"
                 type="password"
                 placeholder="确认密码..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改积分 -->
    <Modal v-model="showChangePointStatus"
           title="修改积分"
           @on-ok="updatePoint()"
           :loading="loading">
      <Form :model="userPoint"
            action="javascript:void(0)">
        <FormItem label="方式"
                  label-position="top">
          <RadioGroup v-model="userPoint.type">
            <Radio label="1"
                   value="1">增加</Radio>
            <Radio label="2"
                   value="2">减少</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="积分">
          <Input v-model="userPoint.points"
                 type="number"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "user-list",
  data () {
    return {
      tablelist: [],
      formItem: {
        key: ""
      },
      dataloading: false,
      loading: false,
      showEditPwdStatus: false,
      showChangePointStatus: false,
      pages: {
        page: 1,
        size: 10
      },
      id: 0,
      datePic: [], //日期
      userPwd: {
        password: "",
        password_confirmation: ""
      },
      userPoint: {
        type: 1,
        point: 1
      },
      userPwdValidate: {
        password: [
          { required: true, message: "密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur"
          }
        ],
        password_confirmation: [
          { required: true, message: "确认密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur"
          }
        ]
      },
      list: [
        // {
        //     title: 'Id',
        //     key: 'uuid',
        //     width: 270,
        //     fixed: 'left'
        // },
        {
          title: "昵称",
          minWidth: 350,
          key: "nickname",
          fixed: "left",
          render: (h, params) => {
            var a = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.username != null
            )
              a = params.row.userdata.username;
            var c = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.nickname != null
            )
              c = params.row.userdata.nickname;
            var d = "";
            if (params.row.userdata != null && params.row.userdata.uuid != null)
              d = params.row.userdata.uuid;
            var e = "";
            if (params.row != null && params.row.unionid != null)
              e = params.row.unionid;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "用户名：" + a
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "昵称：" + c
              ),
              h(
                "p",
                {
                  style: {
                    color: "#337ab7"
                  }
                },
                "用户ID：" + d
              ),
              h(
                "p",
                {
                  style: {
                    color: "#337ab7"
                  }
                },
                "UNIONID：" + e
              )
            ]);
          }
        },
        {
          title: "账号",
          minWidth: 350,
          key: "nickname",
          render: (h, params) => {
            var e = "";
            if (params.row != null && params.row.openid != null)
              e = params.row.openid;
            var f = "";
            if (params.row != null && params.row.map_mp_openid != null)
              f = params.row.map_mp_openid;
            var g = "";
            if (params.row != null && params.row.im_username != null)
              g = params.row.im_username;
            var k = "";
            if (params.row != null && params.row.made_map_openid != null)
              k = params.row.made_map_openid;
            var i = "";
            if (params.row != null && params.row.manghe_map_openid != null)
              i = params.row.manghe_map_openid;
            var l = "";
            if (params.row != null && params.row.newminiprogram_openid != null)
              l = params.row.newminiprogram_openid;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "微信ID：" + e
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "小程序ID：" + f
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "环信ID：" + g
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "定制小程序ID：" + k
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "盲盒小程序ID：" + i
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "新小程序ID：" + l
              )
            ]);
          }
        },
        //     render: (h, params) => {
        //         return h('span', {}, (params.row.userdata != null ? params.row.userdata.nickname : ''));
        //     }
        // },
        {
          title: "电话",
          width: 150,
          key: "username"
        },
        {
          title: "邮箱",
          width: 150,
          render: (h, params) => {
            return h(
              "span",
              {},
              params.row.userdata != null ? params.row.userdata.emails : ""
            );
          }
        },
        {
          title: "余额",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              {},
              params.row.useraccount != null
                ? params.row.useraccount.user_money
                : ""
            );
          }
        },
        {
          title: "积分",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              {},
              params.row.useraccount != null
                ? params.row.useraccount.new_points
                : ""
            );
          }
        },
        {
          title: "最后登录时间",
          width: 180,
          key: "updated_at"
        },
        {
          title: "注册时间",
          width: 180,
          key: "created_at"
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.userdata.status == 1 ? true : false //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.uuid, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 450,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showEditPwd(params.row.uuid);
                    }
                  }
                },
                "改密"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showChangePoint(params.row.uuid);
                    }
                  }
                },
                "更改积分"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.userconsume(params.row.uuid);
                    }
                  }
                },
                "消费记录"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.editaddress(params.row.uuid);
                    }
                  }
                },
                "修改地址"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.userinvoice(params.row.uuid);
                    }
                  }
                },
                "用户发票"
              )
            ]);
          }
        }
      ]
    };
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.user.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    //选择日期
    changeDate (val) {
      this.formItem.datetime = val;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.user
        .status({
          id: index,
          status: value
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
          }
        });
    },
    updatePoint: function (index, value) {
      this.$api.user
        .changepoint({
          uuid: this.id,
          type: this.userPoint.type,
          points: this.userPoint.points,
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
          }
        });
    },
    // 展开修改密码
    showEditPwd (value) {
      this.id = value;
      (this.userPwd = {
        password: "",
        password_confirmation: ""
      }),
        this.showEditPwdStatus = true;
    },
    showChangePoint (value) {
      this.id = value;
      this.userPoint.type = 1;
      this.userPoint.points = 0;
      this.showChangePointStatus = !this.showChangePointStatus
    },
    // 修改密码
    updatePassword: function (name) {
      this.loading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.userPwd.password != this.userPwd.password_confirmation) {
            this.$Message.error("两次密码不一致");
            this.loading = false;
            return;
          }
          this.$api.user
            .editpwd({
              id: this.id,
              password: md5(this.userPwd.password),
              password_confirmation: md5(this.userPwd.password_confirmation)
            })
            .then(res => {
              this.loading = false;
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showEditPwdStatus = false;
              }

            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
        }
      });
    },
    userinvoice (uuid) {
      this.$router.push("/userinvoice/list/" + uuid);
    },
    //消费记录
    userconsume (value) {
      this.$router.push("consume/list/" + value);
    },
    //地址管理
    editaddress (value) {
      this.$router.push("address/list/" + value);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      // var starttime = this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : '';
      // var endtime = this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : '';
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
        // "starttime": starttime,
        // "endtime": endtime,
      };
      this.$api.user.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
</style>